var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M2 13.75V7.25C2 5.45792 3.45792 4 5.25 4H21V17H16V19C16 21.2056 14.2056 23 12 23C9.79442 23 8 21.2056 8 19V17H5.25C3.45792 17 2 15.542 2 13.75ZM18.5 8C18.5 7.44775 18.0522 7 17.5 7C16.9478 7 16.5 7.44775 16.5 8C16.5 8.55225 16.9478 9 17.5 9C18.0522 9 18.5 8.55225 18.5 8ZM4 7.25V7.40002L4.69995 8.20001L4 9V9.71002L4.69995 10.4581L4 11.3V12L4.69995 12.79L4 13.6V13.7C4 14.4403 4.55967 15 5.25 15H10V19C10 20.1045 10.8955 21 12 21C13.1046 21 14 20.1045 14 19V6H5.25C4.55967 6 4 6.55958 4 7.25Z'
      })
    ),
    props
  );
}

module.exports = Icon;
